/* eslint-disable */

const config = {
    hackle: {
        key:
            "mHLlaqSiEjXOIaUzVPmxr5mZDEF5wTS9"
    },
    flounder: {
        cognitoKey:
            "ap-northeast-2:836ea2e6-cfdd-4b49-a481-152477b6dac2"
    },
    amplitude: {
        key:
            "2e2e5a386856efdf3237cf254a9d14d9"
    },
    scc: {
        url: "https://spartacodingclub.kr",
    },
    online: {
        url: "https://online.spartacodingclub.kr",
    },
    production: true
};

export { config };